module.exports = "/site/themes/rkt/_/buckleys/node_modules/@fortawesome/fontawesome-pro/webfonts/fa-light-300.ttf";


//////////////////
// WEBPACK FOOTER
// ../~/@fortawesome/fontawesome-pro/webfonts/fa-light-300.ttf
// module id = 66
// module chunks = 3